/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = GiftVoucherItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemsEditor extends Common.GridEditorBase<GiftVoucherItemsRow> {


        protected getColumnsKey() { return "Retail.GiftVoucherItems"; }
        protected getDialogType() { return GiftVoucherItemsDialog; }
        protected getLocalTextPrefix() { return GiftVoucherItemsRow.localTextPrefix; }
        protected form: GiftVoucherItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};



        constructor(container: JQuery) {
            super(container);

        }
        validateEntity(row: GiftVoucherItemsRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.GiftMasterId = Q.toId(row.GiftMasterId);

            var sameGift= Q.tryFirst(this.view.getItems(), x => x.GiftMasterId === row.GiftMasterId);
            if (sameGift && this.id(sameGift) !== id) {
                Q.alert('This Component is already in  details!');
                return false;
            }

            //update values in grid

            //row.Code = OMS.GiftVoucherMasterRow.getLookup().itemById[row.GiftMasterId].Code;
            return true;
        }    

    }
}